"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CommonMultiCarousel = void 0;
var _commonMultiCarousel = _interopRequireDefault(require("./components/common-multi-carousel"));
exports.CommonMultiCarousel = _commonMultiCarousel["default"];